import { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../../redux/slice/userSlice";

const ResetPasswordForm = () => {
  const token = useParams().token;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [cpassword, setCpassword] = useState("");
  const [cpasswordError, setCpasswordError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    var err = false;

    if (!password) {
      setPasswordError("Password is required");
      err = true;
    } else if (password.length < 6) {
      setPasswordError("Too short");
      err = true;
    } else if (password !== cpassword) {
      setPasswordError("Passwords do not match!");
      err = true;
    }
    if (!cpassword) {
      setCpasswordError("Confirm password is required");
      err = true;
    }

    if (!err) {
      const data = { token, data: { password } };
      const result = await dispatch(resetPassword(data)).unwrap();
      if (result) {
        navigate("/login", {
          replace: true,
          state: { message: "Password changed successfully." },
        });
      }
    }
  };

  const handlePasswordVisibility = (e) => {
    setPasswordVisibility((prev) => !prev);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-5">
        {/* New password input container */}
        <div className="w-full flex flex-col">
          <label
            htmlFor="password"
            className="text-textPrimary font-medium pb-3"
          >
            New Password*
          </label>

          <div className="block">
            <button
              type="button"
              className="absolute mt-5 sm:ml-[380px] ml-[230px] text-[12px]"
              onClick={handlePasswordVisibility}
              tabIndex="-1"
            >
              {passwordVisibility ? (
                <FaRegEye className="text-[18px]" />
              ) : (
                <FaRegEyeSlash className="text-[18px]" />
              )}
            </button>
            <input
              type={passwordVisibility ? "text" : "password"}
              id="password"
              name="password"
              className="w-full login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary password-input"
              placeholder="New Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError("");
              }}
            />
          </div>
          <span className="pl-4 text-[12px] italic text-red-500 pt-3">
            {passwordError}
          </span>
        </div>

        {/* confirm password container */}
        <div className="w-full flex flex-col gap-3">
          <label htmlFor="cpassword" className="text-textPrimary font-medium">
            Confirm Password*
          </label>
          <input
            type="password"
            id="cpassword"
            name="cpassword"
            value={cpassword}
            onChange={(e) => {
              setCpassword(e.target.value);
              setPasswordError("");
              setCpasswordError("");
            }}
            className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
            placeholder="New Password"
          />
          <span className="pl-4 text-[12px] italic text-red-500">
            {cpasswordError}
          </span>
        </div>
        {/*  reset button */}
        <div className="flex text-center flex-col mt-4 gap-6">
          <button
            type="submit"
            className="h-[52px] bg-secondary rounded-md text-primary text-xl font-mediumm"
          >
            Reset password
          </button>
        </div>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
